module.exports = __webpack_public_path__ + "static/media/comingsoon.f0abc032.svg";